// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.profile-contact-container {   
  padding: 70px 20px 40px;
    margin: 20px auto; 
    background-color: #fff; 
    border: 1px solid #ddd;
    border-radius: 8px; 
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }

.profile-contact-fetch-data {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
}  

.profile-contact-fetch-data label {
    width: 150px;
    font-weight: bold;
    text-align: left;
    white-space: nowrap;
}

.profile-contact-fetch-data input[type="text"] {
    width: 30%;
    background-color: #e9ecef;
    color: #373435;
}

.profile-logo-wrap {
    margin: -25px 0 10px 0;
}

.profile-logo {
    display: block;
    margin: 0 auto;
    height: 100px; 
    width: 150px; 
    object-fit: contain; 
    border-radius: 30px;
  }

/* Password Change Section */
.change-password-field {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
}  

.change-password-field input[type="password"] {
    width: 30%;
    color: #373435;
    padding: 10px;
    border: 1px solid #d1d1d1;
    border-radius: 4px;
}

.change-password-field label {
    text-align: left;
    width: 32%;
}

  .change-password-btn .submit-button {
    background-color: #44a67e;
    margin-top: 20px;
    padding: 15px 20px;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }
  
  .change-password-btn .submit-button:hover {
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  }

  .change-password-btn .cancel-button {
    background-color: #fb3d4e;
    margin-top: 20px;
    padding: 15px 20px;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    margin-left: 10px;
  }

  .change-password-btn .cancel-button:hover {
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  }

  .wrap-profile-page {
    margin: 0 40px;
  }

  .password-requirements {
    background: #ffcc29;
    color: #373435;
    padding: 10px 40px;
    border: 1px solid #ffeeba;
    border-radius: 5px;
    margin-top: 15px;
    font-size: 14px;
    width: fit-content;
    margin-left: auto;
    margin-right: auto;
  }

  .password-requirements ul {
    margin: 5px 0;
    padding-left: 20px;
  }
  .password-requirements li {
    list-style-type: disc;
    text-align: justify;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Profile/Profile.css"],"names":[],"mappings":";AACA;EACE,uBAAuB;IACrB,iBAAiB;IACjB,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;EAC1C;;AAEF;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,cAAc;IACd,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;EACrB;;AAEF,4BAA4B;AAC5B;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,cAAc;IACd,aAAa;IACb,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;EAEE;IACE,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,mBAAmB;EACrB","sourcesContent":["\r\n.profile-contact-container {   \r\n  padding: 70px 20px 40px;\r\n    margin: 20px auto; \r\n    background-color: #fff; \r\n    border: 1px solid #ddd;\r\n    border-radius: 8px; \r\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n  }\r\n\r\n.profile-contact-fetch-data {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin-bottom: 10px;\r\n}  \r\n\r\n.profile-contact-fetch-data label {\r\n    width: 150px;\r\n    font-weight: bold;\r\n    text-align: left;\r\n    white-space: nowrap;\r\n}\r\n\r\n.profile-contact-fetch-data input[type=\"text\"] {\r\n    width: 30%;\r\n    background-color: #e9ecef;\r\n    color: #373435;\r\n}\r\n\r\n.profile-logo-wrap {\r\n    margin: -25px 0 10px 0;\r\n}\r\n\r\n.profile-logo {\r\n    display: block;\r\n    margin: 0 auto;\r\n    height: 100px; \r\n    width: 150px; \r\n    object-fit: contain; \r\n    border-radius: 30px;\r\n  }\r\n\r\n/* Password Change Section */\r\n.change-password-field {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin-bottom: 10px;\r\n}  \r\n\r\n.change-password-field input[type=\"password\"] {\r\n    width: 30%;\r\n    color: #373435;\r\n    padding: 10px;\r\n    border: 1px solid #d1d1d1;\r\n    border-radius: 4px;\r\n}\r\n\r\n.change-password-field label {\r\n    text-align: left;\r\n    width: 32%;\r\n}\r\n\r\n  .change-password-btn .submit-button {\r\n    background-color: #44a67e;\r\n    margin-top: 20px;\r\n    padding: 15px 20px;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .change-password-btn .submit-button:hover {\r\n    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\r\n  }\r\n\r\n  .change-password-btn .cancel-button {\r\n    background-color: #fb3d4e;\r\n    margin-top: 20px;\r\n    padding: 15px 20px;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    margin-left: 10px;\r\n  }\r\n\r\n  .change-password-btn .cancel-button:hover {\r\n    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\r\n  }\r\n\r\n  .wrap-profile-page {\r\n    margin: 0 40px;\r\n  }\r\n\r\n  .password-requirements {\r\n    background: #ffcc29;\r\n    color: #373435;\r\n    padding: 10px 40px;\r\n    border: 1px solid #ffeeba;\r\n    border-radius: 5px;\r\n    margin-top: 15px;\r\n    font-size: 14px;\r\n    width: fit-content;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n  }\r\n\r\n  .password-requirements ul {\r\n    margin: 5px 0;\r\n    padding-left: 20px;\r\n  }\r\n  .password-requirements li {\r\n    list-style-type: disc;\r\n    text-align: justify;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
